import { render, staticRenderFns } from "./StudentStudyRecords.vue?vue&type=template&id=0cc3a176"
import script from "./StudentStudyRecords.vue?vue&type=script&lang=ts"
export * from "./StudentStudyRecords.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports